




















































import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import ClassifiedSearchResultsPagination from '~/components/car/classifieds/search/results/ClassifiedSearchResultsPagination.vue'
import { defineComponent, computed } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { ciTop } from '~/icons/source/regular/top'
import { useNamespacedStore } from '~/compositions/store'
import { useScroll } from '~/compositions/scroll'
import { useSearchBottomAds } from '~/compositions/ad'
import { useUserAgent } from '~/compositions/user-agent'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'

export default defineComponent({
  components: {
    CPosting,
    CGoogleAd,
    ClassifiedSearchResultsPagination
  },
  setup() {
    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { scrollToTop } = useScroll()
    const { fullAd, leftAd, rightAd } = useSearchBottomAds()
    const { isPc } = useUserAgent()

    const loadingResults = computed(() => classifiedSearchState.loading.results)

    const rows = computed(() => classifiedSearchState.rows)

    const totalRows = computed(() => classifiedSearchGetters('getTotalRows'))

    const adsKeyValues = computed(() =>
      classifiedSearchGetters('getAdsKeyValues')
    )

    const inXymaSearch = computed(() => classifiedSearchGetters('inXymaSearch'))

    const isJobsSearch = computed(() => classifiedSearchGetters('isJobsSearch'))

    const shouldDisplayAds = computed(() =>
      classifiedSearchGetters('shouldDisplayAds')
    )

    const showFullAd = computed(() => inXymaSearch.value || isJobsSearch.value)

    function onBackToTopButtonClick() {
      scrollToTop({ duration: 500, easing: 'ease-out' })
    }

    return {
      ciTop,
      totalRows,
      loadingResults,
      fullAd,
      leftAd,
      rightAd,
      isPc,
      adsKeyValues,
      showFullAd,
      shouldDisplayAds,
      rows,
      onBackToTopButtonClick
    }
  },
  i18n: defineComponentTranslations({
    back_to_top: {
      en: 'Back to top',
      el: 'Μετάβαση στην αρχή'
    }
  })
})
